import React, { ReactNode } from 'react';
import { Typography } from 'glints-aries/es/@next';
import { FormattedMessage } from 'react-intl';

import {
  NotificationCategory,
  NotificationChannel,
} from '../../../../../common/constants';
import { useGetUserNotificationPreferences } from '../../../../../common/hooks/useGetUserNotificationPreferences';
import { Messages, Variant } from './constants';

export const VerificationSuccessStep = ({ variant }: { variant: Variant }) => {
  const { data: userNotificationPreferencesData } =
    useGetUserNotificationPreferences({
      fetchPolicy: 'cache-only',
    });

  const optInForUpdates = Boolean(
    userNotificationPreferencesData?.getUserNotificationPreferenceCategories
      .find(
        category =>
          category.name === NotificationCategory.APPLICATION ||
          category.name === NotificationCategory.JOB
      )
      ?.userNotificationPreferences.find(
        preference => preference.channel === NotificationChannel.WHATSAPP
      )?.enabled
  );

  const messages = Messages(optInForUpdates)[variant];

  return (
    <>
      <Typography variant="body1">
        <FormattedMessage {...messages.body1} />
      </Typography>
      <br />
      <Typography variant="body1">
        <FormattedMessage
          {...messages.body2}
          values={{
            bold: (text: ReactNode) => (
              <Typography variant="body2" as="span">
                {text}
              </Typography>
            ),
            br: <br />,
          }}
        />
      </Typography>
    </>
  );
};
